// extracted by mini-css-extract-plugin
module.exports = {"colTextCheck":"style_colTextCheck__3ur0g"};